import { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

export default function FullscreenOverlay({ children }: {children: ReactNode}) {
  const [fsTarget, setFsTarget] = useState(null);

  useEffect(() => {
    const updateFsTarget = () => {
      // @ts-ignore
      setFsTarget(document.fullscreenElement!);
    };

    document.addEventListener("fullscreenchange", updateFsTarget);
    updateFsTarget(); // handle initial state

    return () => {
      document.removeEventListener("fullscreenchange", updateFsTarget);
    };
  }, []);

  if (!fsTarget) return null;

  return createPortal(
    children,
    fsTarget
  );
}
